import { NewMembersService } from './new-members-service';

export default NewMembersService;
